import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Button, Row, Col } from "react-bootstrap";
import SearchFilter from "../../../../components/SearchFilter";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import Table from "../../../../components/Table";
import ButtonOptionSubmenu from "../../../../components/ButtonOptionSubmenu";
import { addEditServiceRequest, getServiceRequest } from "../../../../commons/ServiceRequest";
import { useAlert } from "../../../../context/AlertContext";
import { formatInputDate } from "../../../../utils/Time";
import TechScheduleCusService from "../../../../services/techschedulecus.service";
import { formatDateTime } from "../../../../commons/FormatValue";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import { Helmet } from "react-helmet-async";
import InputSearch from "../../../../components/InputSearhComponent";
import { getQueryString } from "../../../../utils/Query";

export default function ContactAppointCus() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [loading, setLoading] = useState(false);
  const defaultDatas = [
    {
      rowIndex: 0,
      sup_team: "",
      jobtype_name: "",
      Service_req_no: "",
      Cus_code: "",
      Cus_name: "",
      Item_name: "",
      job_start_date: "",
      job_finish_date: "",
      job_actual_date: "",
      tech_mas_name: "",
      technician_work_status: "",
      seq_st_name: "",
      seq_st_job: "",
      reject_reson: ""
    }
  ];

  const [data, setData] = useState({ Array: [defaultDatas] });
  const [searchValue, setSearchValue] = useState([]);
  const [supTeam, setSupTeam] = useState("");
  const [tableData, setTableData] = useState([]);
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allCountData, setAllCountData] = useState();

  const columns = [
    {
      name: "ลำดับ",
      selector: (row) => row.rowIndex,
      sortable: true,
      width: "110px"
    },
    {
      name: "เลขที่ใบสั่งงาน",
      selector: (row) => row.Seq_No,
      width: "180px",
      readOnly: true,
    },
    {
      name: "รหัสลูกค้า/สาขา",
      selector: (row) => row.Cus_Code,
      width: "180px",
      readOnly: true
    },
    {
      name: "เลขที่สาขา",
      selector: (row) => row.Branch_No,
      readOnly: true
    },
    {
      name: "ชื่อลูกค้า/สาขา",
      selector: (row) => row.Cus_Name,
      width: "250px",
      readOnly: true
    },
    {
      name: "วันที่เข้างาน",
      selector: (row) => row.Job_Actual_Date,
      readOnly: true,
      width: "150px"
    },
    {
      name: "ผู้ติดต่อ",
      selector: (row) => row.Tech_Name,
      width: "180px",
      readOnly: true
    },
    {
      name: "เบอร์ติดต่อ",
      selector: (row) => row.Tech_Tel,
      readOnly: true,
      width: "150px"
    },
    {
      name: "วันเวลาโทรนัดหมาย",
      selector: (row) => formatDateTime(row.Appointment_Tel_Date, "DD/MM/YYYY HH:mm น."),
      width: "202px",
      readOnly: true
    },
    {
      name: "วันเวลานัดหมาย",
      selector: (row) => formatDateTime(row.Appointment_Date, "DD/MM/YYYY HH:mm น."),
      width: "202px",
      readOnly: true
    },
    {
      name: "วันเวลาเข้างานจริง",
      selector: (row) => formatDateTime(row.Work_Actual_Date, "DD/MM/YYYY HH:mm น."),
      width: "202px",
      readOnly: true
    },
    {
      name: "",
      selector: (row) => (
        <ButtonOptionSubmenu
          data={row}
          state={{ preview: filteredArray(row.id) }}
          editButton
          deleteButton
          onDeleteCallback={handleSubmitDelete}
        />
      ),
      right: true,
      width: "170px"
    }
  ];
  const filteredArray = (Id) => {
    return tableData.filter(item => item.Id === Id);
  }

  const searchInput = [
    {
      name: "sup_team",
      label: "ชื่อทีม/หัวหน้าช่าง",
      classNames: { label: "mb-3" },
      type: "text",
      value: supTeam,
      disabled: true,
      size: 3
    },
    {
      name: "sup_team",
      label: "ช่างผู้ปฏิบัติงาน",
      classNames: { label: "mb-3" },
      type: "text",
      value: supTeam,
      disabled: true,
      size: 3
    },
    {
      name: "start",
      label: "วันที่นัดหมายระหว่างวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      // value: currentDate
    },
    {
      name: "end",
      label: "ถึงวันที่",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3,
      min: 'start'
    }
  ];

  const handleSubmitDelete = (event, dataCallback) => {
    event.preventDefault();

    if (dataCallback) {
      submitDelete(dataCallback.Id);
      fetchData()
    }
  };

  const submitDelete = async (id) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechScheduleCusService.deleteScheduleCustomer(id),
      navigated: (navi) => navi && navigate("/service_work/acceptance", {
        state: { name: "CheckJobDetails" }
      })
    });
  };

  useEffect(() => {
    setTimeout(() => setWebsiteName("ข้อมูลการติดต่อและนัดหมายลูกค้า"), 300);
  }, []);
  const [querySearch, setQuerySearch] = useState()

  function fetchData(search) {
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = getQueryString({ ...querySearch, page: page, limit: limit, ...search })
    setCurrentPage(page)
    setRowsPerPage(limit)
    setQuerySearch(q)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechScheduleCusService.getAllScheduleCustomer(q),
      callback: (res) => { pSetData(res.data); setData(res) }
    });
  }
  const pSetData = (vData) => {
    const newArray = vData?.map((items) => ({
      Id: items.id,
      Seq_No: items.TechnicianPlans.SeqOthersJob?.Seq_Oth_No ||
        items.TechnicianPlans.SeqPmJob?.Seq_Pm_No ||
        items.TechnicianPlans.SeqRepairJob?.Seq_Serv_No ||
        items.TechnicianPlans.SeqInstallJob?.Seq_Inst_No,
      Cus_Code: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Customer.Cus_Code,
      Cus_Name: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Customer.Cus_Name,
      Branch_No: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Cus_NumBranch,
      Job_Actual_Date: formatInputDate(items.TechnicianPlans?.job_actual_date, "Local").date,
      Tech_Name: items.TechnicianPlans?.Technician.Tech_Mas_Name,
      Tech_Tel: items.TechnicianPlans?.Technician.Tech_Mas_Tel,
      Appointment_Date: items.appointment_date,
      Appointment_Tel_Date: items.appointment_tel_date,
      Work_Actual_Date: items.work_actual_date,
    }));
    setSearchValue(newArray|| [])
    setTableData(newArray || []);
  };

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <CardDisplayComponent
        header={{ title: { text: "ข้อมูลการติดต่อและนัดหมายลูกค้า" } }}
        cardClassName="text-center"
        body={{
          element: (
            <>
              {/* <SearchFilter
                data={initialData}
                inputField={searchInput}
                searchCallback={handleSearchFilter}
              /> */}
              <InputSearch
                field={searchInput}
                searchCallback={search => search ? fetchData(search) : setSearchValue([])}
              />
            </>
          )
        }}
      />

      <Card className="m-1 mb-4 p-4 border-0">
        <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
          <Card.Title className="mb-0 fs-2 text-dark">
            รายละเอียดข้อมูลที่จะติดต่อและนัดหมายลูกค้า
          </Card.Title>

          <div className="ms-auto">
            <Button
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill h-100"
              onClick={() => navigate("add")}
            >
              เพิ่มการติดต่อและนัดหมายลูกค้า
            </Button>
          </div>
        </Card.Header>

        <Card.Body>
          <Table
            data={searchValue}
            column={columns}
            pending={loading}
            searchFilter={searchValue}
            pagination
          />
        </Card.Body>

        <Row className="justify-content-end p-3">
          <Col className="col-auto">
            <Button
              variant="outline-secondary"
              className="px-4 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("/service_work/acceptance", {
                  state: { name: "CheckJobDetails" }
                })
              }
            >
              ย้อนกลับ
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  );
}
